// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"683077ee","296":"9421e941","302":"96ffeee6","304":"886392f0","453":"a008db69","477":"913f3421","577":"8a4220e2","718":"734f9e7a","942":"0657fde2","998":"4d1a47d6"}[chunkId] + ".chunk.js";
};